import { render, staticRenderFns } from "./BillFunction.vue?vue&type=template&id=efb1964a&scoped=true&"
import script from "./BillFunction.vue?vue&type=script&lang=js&"
export * from "./BillFunction.vue?vue&type=script&lang=js&"
import style0 from "./BillFunction.vue?vue&type=style&index=0&id=efb1964a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb1964a",
  null
  
)

export default component.exports